import React, { Component } from 'react';

class TableCheckbox extends Component  {

  handleOnChange = () => {
    const { checked } = this.props;

    this.props.onChange(!checked);
  }

  render() {
    const { partial, checked, value } = this.props;
    let checkedClass = !!checked ? 'it-checkbox-checked' : '';

    if (!!partial && !checked) {
      checkedClass = 'it-checkbox-indeterminate';
    }

    return (
      <label className="it-checkbox-wrapper it-checkbox-wrapper-checked"
        onClick={ this.handleOnChange }
      >
        <span className={ `it-checkbox ${checkedClass}` }>
          <input type="checkbox"
            className="it-checkbox-input"
            value={ value }
          />
          <span className="it-checkbox-inner"></span>
        </span>
      </label>
    );
  }
}

export default TableCheckbox;